import React, { useState, useEffect } from 'react'
import { useStore } from '@nanostores/react'
import { userData } from '@stores/userStore'
import { cartData } from '@stores/cartStore'
import Plus from '@components/Icons/Plus.jsx'
import Minus from '@components/Icons/Minus.jsx'
import { registryData } from '@stores/registryStore'
import { chord } from '@api/chord.js'
import { updateCartDiscountCodes, getCart } from '@api/shopify'
import * as nav from '@data/navdata'

const SubnavAccount = ({
    activeSubSubnav,
    setActiveSubSubnav,
    handleToggleSubSubnav,
}) => {
    const $userData = useStore(userData || null)
    const [haveUser, setHaveUser] = useState(false)

    //

    useEffect(() => {
        if ($userData && $userData.isLoggedIn) {
            setHaveUser(true)
        } else {
            setHaveUser(false)
        }
    }, [])

    useEffect(() => {
        if ($userData && $userData.isLoggedIn) {
            setHaveUser(true)
        } else {
            setHaveUser(false)
        }
    }, [$userData])

    // Helper function to check if a discount code is from Inveterate
    const isInveterateDiscountCode = (code) => {
        return code && code.startsWith('REDEEM+');
    };

    // Remove Inveterate discount codes from cart
    const removeInveterateDiscounts = async () => {
        const currentCartData = cartData.get();

        if (!currentCartData?.cartId || !currentCartData?.discountCodes) {
            console.log('No cart data or discount codes to remove');
            return;
        }

        console.log('Removing Inveterate discounts on logout...');

        // Filter out Inveterate discount codes
        const nonInveterateDiscounts = currentCartData.discountCodes
            .filter(dc => dc.applicable && !isInveterateDiscountCode(dc.code))
            .map(dc => dc.code);

        const inveterateDiscounts = currentCartData.discountCodes
            .filter(dc => dc.applicable && isInveterateDiscountCode(dc.code));

        if (inveterateDiscounts.length > 0) {
            console.log('Found Inveterate discount codes to remove on logout:', inveterateDiscounts.map(dc => dc.code));

            try {
                // Update cart with only non-Inveterate discount codes
                const discountResult = await updateCartDiscountCodes(currentCartData.cartId, nonInveterateDiscounts);

                if (discountResult.body?.cartDiscountCodesUpdate?.cart) {
                    const updatedCart = discountResult.body.cartDiscountCodesUpdate.cart;

                    console.log('Successfully removed Inveterate discounts on logout');

                    // Update cart store with new data
                    const cartObj = {
                        ...currentCartData,
                        cost: updatedCart.cost,
                        lines: updatedCart.lines.edges,
                        discountCodes: updatedCart.discountCodes,
                        discountAllocations: updatedCart.discountAllocations,
                    };

                    cartData.set(cartObj);
                }
            } catch (error) {
                console.error('Failed to remove Inveterate discount codes on logout:', error);
            }
        } else {
            console.log('No Inveterate discount codes found in cart on logout');
        }
    };

    const handleLogout = async () => {
        console.log('Logout initiated from subnav - clearing user data and removing Inveterate discounts...');

        // Remove Inveterate discounts before clearing user data
        await removeInveterateDiscounts();

        // Clear user data
        userData.set({});
        registryData.set({});
        localStorage.removeItem('ma_user');
        chord.reset();
        localStorage.setItem('hasRegistry', 'false');
        document.cookie =
            'access_token=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT'
        document.cookie =
            'ma_registry_id=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT'

        console.log('Logout completed - user data cleared and Inveterate discounts removed');

        setTimeout(() => {
            window.location.href = '/'
        }, 1000)
    }

    return (
        <nav className="subnav-wrap" role="navigation">
            <div className="nav-wrap py-2">
                <ul className="nostyle ">
                    <li key="login" className="py-1 text-sm font-normal">
                        {!haveUser ? (
                            <a
                                className="flex items-center"
                                href="/account/login"
                            >
                                <span className="">Login</span>
                            </a>
                        ) : null}
                    </li>
                    <li key="account" className="py-1 text-sm font-normal">
                        {haveUser ? (
                            <a className="flex items-center" href="/account">
                                <span className="">Account Details</span>
                            </a>
                        ) : (
                            <a
                                className="flex items-center"
                                href="/account/register"
                            >
                                <span className="">Create An Account</span>
                            </a>
                        )}
                    </li>
                    {/* <li key="registry" className="py-1 text-sm font-normal">
                        <a
                            className="flex items-center"
                            href="/pages/registry"
                        >
                            <span className="">Registry</span>
                        </a>
                    </li> */}
                    {haveUser ? (
                        <li key="logout" className="py-1 text-sm font-normal">
                            <span className="" onClick={handleLogout}>
                                Log out
                            </span>
                        </li>
                    ) : null}
                </ul>
            </div>
        </nav>
    )
}

export default SubnavAccount
